import * as React from "react";

function SvgAdobe(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1847.3 1648.5"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M.2 0h685.7L.2 1670V0zm1152.9 0h694.3v1648.5L1153.1 0zM927.4 638.6L1305.9 1640h-234.3l-161.4-317.1H653.1l274.3-684.3z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#cc2229"
      />
    </svg>
  );
}

export default React.forwardRef(SvgAdobe);
